// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #region Port */
.port {
  fill: var(--wfc-port-fill);
  stroke: var(--wfc-lines);
  cursor: pointer;
  stroke-width: 3px;
}

.port.highlight {
  fill: var(--wfc-green);
}

.port.unselected {
  fill: color-mix(in srgb, var(--wfc-port-fill) var(--wfc-unselected-blend), var(--wfc-bg));
  stroke: color-mix(in srgb, var(--wfc-lines) var(--wfc-unselected-blend), var(--wfc-bg));
}

.port-hitbox {
  fill: rgba(255, 255, 255, 0);
  cursor: pointer;
  stroke-width: 0;
}

/* #endregion */
/* #region Node */
.node {
  stroke: none;
  cursor: pointer;
  transition: 0.05s linear;
  transition-property: filter, -moz-filter;
}

.node.selected {
  filter: saturate(65%) brightness(74%);
}

.node.unselected {
  filter: saturate(15%) brightness(185%);
}

/* #endregion */
/* #region Stroke */
.stroke {
  fill: none;
  stroke: #95999e;
  stroke-width: 1px;
}

.stroke.selected {
  stroke-width: 2px;
}

.stroke.unselected {
  fill: #b5b5b5;
}

/* #endregion */
/* #region Icon */
.icon {
  font-family: "Material Icons";
  fill: var(--wfc-icon);
  stroke: none;
  cursor: pointer;
}

.icon.unselected {
  fill: #dedede;
}

.icon.special {
  fill: #eceff4;
}

/* #endregion */
/* #region Title and Label */
.title {
  fill: var(--wfc-text-color);
  font-weight: normal;
  pointer-events: none;
}

.title.unselected {
  fill: color-mix(in srgb, var(--wfc-text-color) var(--wfc-unselected-blend), var(--wfc-label-color));
}

.label {
  fill: var(--wfc-label-color);
  pointer-events: none;
}

.label.unselected {
  fill: color-mix(in srgb, var(--wfc-label-color) var(--wfc-unselected-blend), var(--wfc-bg));
}

/* #endregion */`, "",{"version":3,"sources":["webpack://./src/app/components/models/definition/workflow-canvas/workflow-canvas-node.component.scss"],"names":[],"mappings":"AAAA,iBAAA;AACA;EACE,0BAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,yFAAA;EACA,uFAAA;AACF;;AAEA;EACE,4BAAA;EACA,eAAA;EACA,eAAA;AACF;;AACA,eAAA;AAEA,iBAAA;AACA;EACE,YAAA;EACA,eAAA;EACA,wBAAA;EACA,wCACE;AAAJ;;AAKA;EACE,qCAAA;AAFF;;AAKA;EACE,sCAAA;AAFF;;AAIA,eAAA;AAEA,mBAAA;AACA;EACE,UAAA;EACA,eAAA;EACA,iBAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,aAAA;AAFF;;AAIA,eAAA;AAEA,iBAAA;AACA;EACE,6BAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;AAFF;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,aAAA;AAFF;;AAIA,eAAA;AAEA,4BAAA;AACA;EACE,2BAAA;EACA,mBAAA;EACA,oBAAA;AAFF;;AAKA;EACE,mGAAA;AAFF;;AAKA;EACE,4BAAA;EACA,oBAAA;AAFF;;AAKA;EACE,2FAAA;AAFF;;AAIA,eAAA","sourcesContent":["/* #region Port */\n.port {\n  fill: var(--wfc-port-fill);\n  stroke: var(--wfc-lines);\n  cursor: pointer;\n  stroke-width: 3px;\n}\n\n.port.highlight {\n  fill: var(--wfc-green);\n}\n\n.port.unselected {\n  fill: color-mix(in srgb, var(--wfc-port-fill) var(--wfc-unselected-blend), var(--wfc-bg));\n  stroke: color-mix(in srgb, var(--wfc-lines) var(--wfc-unselected-blend), var(--wfc-bg));\n}\n\n.port-hitbox {\n  fill: #ffffff00;\n  cursor: pointer;\n  stroke-width: 0;\n}\n/* #endregion */\n\n/* #region Node */\n.node {\n  stroke: none;\n  cursor: pointer;\n  transition: 0.05s linear;\n  transition-property:\n    filter,\n    -webkit-filter,\n    -moz-filter;\n}\n\n.node.selected {\n  filter: saturate(65%) brightness(74%);\n}\n\n.node.unselected {\n  filter: saturate(15%) brightness(185%);\n}\n/* #endregion */\n\n/* #region Stroke */\n.stroke {\n  fill: none;\n  stroke: #95999e;\n  stroke-width: 1px;\n}\n\n.stroke.selected {\n  stroke-width: 2px;\n}\n\n.stroke.unselected {\n  fill: #b5b5b5;\n}\n/* #endregion */\n\n/* #region Icon */\n.icon {\n  font-family: 'Material Icons';\n  fill: var(--wfc-icon);\n  stroke: none;\n  cursor: pointer;\n}\n\n.icon.unselected {\n  fill: #dedede;\n}\n\n.icon.special {\n  fill: #eceff4;\n}\n/* #endregion */\n\n/* #region Title and Label */\n.title {\n  fill: var(--wfc-text-color);\n  font-weight: normal;\n  pointer-events: none;\n}\n\n.title.unselected {\n  fill: color-mix(in srgb, var(--wfc-text-color) var(--wfc-unselected-blend), var(--wfc-label-color));\n}\n\n.label {\n  fill: var(--wfc-label-color);\n  pointer-events: none;\n}\n\n.label.unselected {\n  fill: color-mix(in srgb, var(--wfc-label-color) var(--wfc-unselected-blend), var(--wfc-bg));\n}\n/* #endregion */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
